export default __webpack_public_path__ + "static/media/Astro_Conjunction_White.0825d07f.png";